/**
 * @module views\mdl\measure
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";

@Component
export default class Measure extends GhBase {
  private argsQuery = { keywords: "" };

  
}
